export const NavbarLinks = [
  {
    title: "Home",
    url: "/",
    cName: "navLinks",
  },
  {
    title: "Who We Are",
    url: "/WhoWeAre",
    cName: "navLinks",
  },
  {
    title: "Events",
    url: "/Events",
    cName: "navLinks",
  },
  {
    title: "Calendar",
    url: "/Calendar",
    cName: "navLinks",
  },
  {
    title: "Prayer Request",
    url: "/PrayerRequest",
    cName: "navLinks",
  },
  {
    title: "Get In Touch",
    url: "/GetInTouch",
    cName: "navLinks",
  },
];
